import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxModalDraggableDirective } from '../../../directives/draggable.directive';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { SenderService } from '../../../services/sender.service';
import { strings as rusStrings } from 'ngx-timeago/language-strings/ru';
import { TimeagoIntl } from 'ngx-timeago';
import { mbg } from '../../../../assets/images/mbg-svg';


@Component({
  selector: 'app-modal-leads-tariff',
  templateUrl: './modal-leads-tariff.component.html',
  styleUrls: ['./modal-leads-tariff.component.scss']
})
export class ModalLeadsTariffComponent implements OnInit {
  public modalDirective: NgxModalDraggableDirective;
  public period = 1;
  public showPromoCode$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  expiredTariff$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  price$: BehaviorSubject<number> = new BehaviorSubject(this.senderService.tariffPrice);
  promoCode = '';

  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }

  img = mbg;

  constructor(
    private intl: TimeagoIntl,
    public senderService: SenderService,
    public bsModalRef: BsModalRef,
  ) {
  }

  ngOnInit(): void {
    this.intl.strings = rusStrings;
    this.intl.changes.next();
    this.senderService.account$.subscribe((account) => {
      const val = this.senderService.expiredTariff();
      this.expiredTariff$.next(val);
    });
  }

  paidTariff() {
    this.senderService.paidTariff('full', this.promoCode, this.period);
  }

  promoCodeStatus() {
    this.promoCode = this.promoCode.toUpperCase();
    if (this.senderService.promoCodes[this.promoCode]) {
      return 'success';
    }
    if (this.promoCode) {
      return 'warning';
    }
    return undefined;
  }

  get hasPromoCode() {
    return this.senderService.promoCodes[this.promoCode];
  }

  calcTariffPrice(): void {
    setTimeout(() => {
      const price = this.senderService.calcTariffPrice(this.promoCode, this.period);
      this.price$.next(price);
    }, 100);
  }
}
